import { set } from 'lodash';

export default function parseLocale(data) {
  const translations = {};

  JSON.parse(data).forEach(locale => set(translations, locale.key, locale.translation));

  return translations;
}
